/**
 * The way in from outside: the extension, an email or an old link from
 * the marketing site sends a person to any page with `?join=sign-up` or
 * `?join=sign-in`, and the page opens that sheet (Create your free
 * account, or Sign in). The webapp is the one home: there is no other
 * site to hand anyone to.
 */

/** The query parameter that asks for a sheet. */
export const JOIN_PARAM = "join";

/** Which sheet an address asked for. */
export type JoinScreen = "sign-in" | "sign-up";

/** The sheet a visitor asked for, from the query string; null when it asks for none. */
export function joinScreen(search: string): JoinScreen | null {
    const asked = new URLSearchParams(search).get(JOIN_PARAM);
    if (asked === "sign-up") return "sign-up";
    if (asked === "sign-in") return "sign-in";
    return null;
}

/** The query string without the ask, for the address the page keeps. */
export function withoutJoin(search: string): string {
    const params = new URLSearchParams(search);
    params.delete(JOIN_PARAM);
    const rest = params.toString();
    return rest ? `?${rest}` : "";
}
